import { useSelector } from 'react-redux';

export { RolePermission } from './roleHooks'
export { PermissionsList, officeManager, branchManager } from './permissionsList'
export { paginate, SavePage, SendPageSave,  } from './paginate'
export { filterByFirstName } from './filterFunctions'
export { activeInactive } from './activeInactive'
export { initAxiosInterceptors } from './axios'
export { searchByType } from './searhcByType'
export { sortByAz } from './sortByAz'
export { ToastSuccess } from './toastSuccess'
export { ToastFail } from './toastFail'
export { FindLoad } from './findLoad'
export { FindSuccess, FindSuccessItem } from './findSuccess'
export { FindError, FindErrorItem } from './findError'
export { PascalCase, makeCapitalize } from './pascalCase'
export { textResizer } from './tableHooks'
export { format } from './dateConverter'
export { useModal, AllModals, ModalProvider} from './modalContext'
export { useSecondaryModal, AllSecondaryModals, SecondaryModalProvider} from './secondaryModal'
export { DownloadFile } from './downloadFile'
export { SaveParams } from './paginate'
export { usePrimaryModal, PrimaryModal, PrimaryModalProvider } from './primaryModal'
export { useTertiaryModal, TertiaryModal, TertiaryModalProvider } from './tertiaryModal'
export { getStars, calculateReviews } from './generateRating'
export { handleGetAgingDate, handleReturnAgingColor} from './agingHooks'
export { sortListByKey } from './sortListByKey'

export const User = () => {
  const { myProfile } = useSelector((state) => ({
    myProfile: state.auth.myProfile,
  }));
  const userLocalInfo = JSON.parse(localStorage.getItem('poloUserInfo'));
  const userInformation = myProfile || userLocalInfo;
  return { userInformation };
};